// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__2mUjZ","x":"Nav_x__DNF5e","links":"Nav_links__BPmbN","arr":"Nav_arr__tOc2l","open":"Nav_open__4U6ws"};